import { render, staticRenderFns } from "./UnassignedPetitionsList.vue?vue&type=template&id=a6a24050"
import script from "./UnassignedPetitionsList.vue?vue&type=script&lang=js"
export * from "./UnassignedPetitionsList.vue?vue&type=script&lang=js"
import style0 from "./UnassignedPetitionsList.vue?vue&type=style&index=0&id=a6a24050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports